// @flow

import React from 'react';
import { InputV2, InputConsumer, NumberInput } from '@catalytic/catalytic-ui';
import { types } from '@catalytic/react-view';
import useFieldContext from './FieldContext';
import { useHandleBlur, useHandleChange } from './ViewHelpers';

const NumberView = (props: types.NumberView) => {
  const { node: getNode, schema: getSchema, setValue, value } = props;
  const node = getNode();
  const schema = getSchema();
  const fieldContext = useFieldContext();
  const {
    className,
    contextValues,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    fieldName,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    readOnly,
    required,
    type
  } = fieldContext || {};
  const handleBlur = useHandleBlur({ onBlur, setValue, type });
  const handleChange = useHandleChange({ onChange, setValue, type });

  return (
    <InputV2
      className={className}
      contextValues={contextValues}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      fieldName={fieldName}
      hasValidation={hasValidation}
      id={id}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      schema={schema}
      title={displayName}
      type={type}
      value={value}
    >
      <InputConsumer>
        {props => (
          <NumberInput
            defaultValue={value}
            embedded={embedded}
            id={id}
            inputMode="decimal"
            name={name}
            required={required}
            step="any"
            format={
              typeof node.maximumFractionDigits === 'number'
                ? {
                    maximumFractionDigits: node.maximumFractionDigits,
                    minimumFractionDigits: node.minimumFractionDigits
                  }
                : undefined
            }
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
NumberView.displayName = 'NumberView';

export default React.memo<types.NumberView>(NumberView);
